import { Typography } from "@mui/material";
import React, { useEffect, useState } from "react";

import PendingChangesView from "../../../../components/PendingChangesView/PendingChangesView";
import {
  BeneficiaryBankInfoMapping,
  BeneficiaryInformationMapping,
  IntermediaryBankInfoMapping,
  ReceivingBankInfoMapping,
} from "../../constant";
import {
  InfoLine,
  ItalicLabel,
  ListContainer,
  PendingInfoDot,
} from "./InvestorPendingView.styles";

type ChangedItem = { label: string; changedKeys: string[] };

const CurrentChange = (leftSectionData: any) => {
  const { currentData, item } = leftSectionData;

  return (
    <div style={{ width: "320px" }}>
      <ItalicLabel>Current</ItalicLabel>
      <span>
        {item?.changedKeys?.map((key: any) => (
          <React.Fragment key={key}>
            <Typography>{currentData?.[key]}</Typography>
          </React.Fragment>
        ))}
      </span>
    </div>
  );
};

const PendingChange = (rightSectionData: any) => {
  const { pendingData, item } = rightSectionData;

  return (
    <div>
      <ItalicLabel>Pending</ItalicLabel>
      <Typography style={{ display: "flex" }}>
        <div>
          <PendingInfoDot />
        </div>
        <div>
          <span>
            {item?.changedKeys?.map((key: any) => (
              <React.Fragment key={key}>
                <Typography>{pendingData?.[key]}</Typography>
              </React.Fragment>
            ))}
          </span>
        </div>
      </Typography>
    </div>
  );
};

const InvestorPendingView = ({
  selectedInvestor,
  selectedInvestorListItem,
  approvePendingChanges,
  declinePendingChanges,
}: any) => {
  const [count, setCount] = useState<number>(0);
  const [receivingBankInfo, setReceivingBankInfo] = useState([]);
  const [beneficiaryBankInfo, setBeneficiaryBankInfo] = useState([]);
  const [beneficiaryInfo, setBeneficiaryInfo] = useState([]);
  const [intermediaryBankInfo, setIntermediaryBankInfo] = useState([]);

  const pendingWireInfo = selectedInvestorListItem?.pendingWireInfo;
  const currentWireInfo = selectedInvestor?.wireInfo;

  const pendingReceivingBankInfo = pendingWireInfo?.receivingBankInfo;
  const currentReceivingBankInfo = currentWireInfo?.receivingBankInfo;

  const pendingBeneficiaryBankInfo = pendingWireInfo?.beneficiaryBankInfo;
  const currentBeneficiaryBankInfo = currentWireInfo?.beneficiaryBankInfo;

  const pendingIntermediaryBankInfo = pendingWireInfo?.intermediaryBankInfo;
  const currentIntermediaryBankInfo = currentWireInfo?.intermediaryBankInfo;

  const isValueChanged = (newData: any, oldData: any, filterableKeys: any) =>
    filterableKeys.filter(
      (key: string) => oldData[key] !== newData[key]
    );

  useEffect(() => {
    let count = 0;
    let receivingInfo: any = [],
      beneficiaryBankInfo: any = [],
      beneficiaryInfo: any = [],
      intermediaryInfo: any = [];

    ReceivingBankInfoMapping.map((changedItem: any) => {
      const keys = isValueChanged(
        pendingReceivingBankInfo,
        currentReceivingBankInfo,
        changedItem.keys
      );

      if (keys.length > 0) {
        receivingInfo = [
          ...receivingInfo,
          { label: changedItem.label, changedKeys: keys },
        ];
      }

      count = count + keys.length;
    });

    BeneficiaryBankInfoMapping.map((changedItem: any) => {
      const keys = isValueChanged(
        pendingBeneficiaryBankInfo,
        currentBeneficiaryBankInfo,
        changedItem.keys
      );

      if (keys.length > 0) {
        beneficiaryBankInfo = [
          ...beneficiaryBankInfo,
          { label: changedItem.label, changedKeys: keys },
        ];
      }

      count = count + keys.length;
    });

    BeneficiaryInformationMapping.map((changedItem: any) => {
      const keys = isValueChanged(
        pendingWireInfo,
        currentWireInfo,
        changedItem.keys
      );

      if (keys.length > 0) {
        beneficiaryInfo = [
          ...beneficiaryInfo,
          { label: changedItem.label, changedKeys: keys },
        ];
      }

      count = count + keys.length;
    });

    IntermediaryBankInfoMapping.map((changedItem: any) => {
      const keys = isValueChanged(
        pendingIntermediaryBankInfo,
        currentIntermediaryBankInfo,
        changedItem.keys
      );

      if (keys.length > 0) {
        intermediaryInfo = [
          ...intermediaryInfo,
          { label: changedItem.label, changedKeys: keys },
        ];
      }

      count = count + keys.length;
    });

    setCount(count);
    setReceivingBankInfo(receivingInfo);
    setBeneficiaryBankInfo(beneficiaryBankInfo);
    setBeneficiaryInfo(beneficiaryInfo);
    setIntermediaryBankInfo(intermediaryInfo);
  }, [selectedInvestor]);

  const RenderChangedItem = (type: string) => {
    let changedItems: ChangedItem[], currentData: any, pendingData: any;

    switch(type) {
      case 'Receiving Bank Info': 
        changedItems = receivingBankInfo;
        currentData = currentReceivingBankInfo;
        pendingData = pendingReceivingBankInfo;
        break;
      case 'Beneficiary Bank Info': 
        changedItems = beneficiaryBankInfo;
        currentData = currentBeneficiaryBankInfo;
        pendingData = pendingBeneficiaryBankInfo;
        break;
      case 'Intermediary Info':
        changedItems = intermediaryBankInfo;
        currentData = currentIntermediaryBankInfo;
        pendingData = pendingIntermediaryBankInfo;
        break;
      default: 
        changedItems = beneficiaryInfo;
        currentData = currentWireInfo;
        pendingData = pendingWireInfo;
        break;    
    }

    return (
      <>
        {changedItems?.length > 0 &&
          changedItems.map((item: ChangedItem) => {
            return (
              <React.Fragment key={item.label}>
                <div key={item.label}>
                  <InfoLine>
                    <Typography variant="label">{item.label}</Typography>
                    <div style={{ display: "flex" }}>
                      {CurrentChange({ currentData, item })}
                      {PendingChange({ pendingData, item })}
                    </div>
                  </InfoLine>
                </div>
              </React.Fragment>
            );
          })}
      </>
    );
  };

  return (
    <PendingChangesView
      declineChanges={declinePendingChanges}
      approveChanges={approvePendingChanges}
      title={`Pending Changes ${count ? `(${count})` : ""}`}
    >
      <ListContainer>
        {RenderChangedItem("Receiving Bank Info")}
        {RenderChangedItem("Beneficiary Bank Info")}
        {RenderChangedItem("Beneficiary Info")}
        {RenderChangedItem("Intermediary Info")}
      </ListContainer>
    </PendingChangesView>
  );
};

export default InvestorPendingView;
